export default "__VITE_ASSET__EtCzOmTP__"